import React, { useRef } from 'react';
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import Container from '../../../../constants/Container';
import SecHeading from '../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import FileTextBox from '../../../../constants/FileTextBox';
import { BSToADUSFormat, NepNowDateFormat } from '../../../../constants/DateFormat';

interface MargaToleAddFormViewProps {
    handleFormSuccess: () => void;
}
const PostalCreateView: React.FC<MargaToleAddFormViewProps> = ({ handleFormSuccess }) => {
    const nepaliCurData = NepNowDateFormat();
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const initialValues = {
        reference_no: "",
        date_ne: nepaliCurData,
        date_en: "",
        from_title: "",
        address: "-",
        note: "",
        to_title: "",
        letter_no: "",
        doc: "",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: toleValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("reference_no", values.reference_no);
            formData.append("date_ne", values.date_ne);
            formData.append("date_en", BSToADUSFormat(values.date_ne));
            formData.append("from_title", values.from_title);
            formData.append("address", values.address);
            formData.append("note", values.note);
            formData.append("to_title", values.to_title);
            formData.append("letter_no", values.letter_no);
            formData.append("doc", values.doc);
            try {
                await postDataToTheServer(AppURL.ApplicationURL + 'app/postal/receive/add/create/view/', formData).then((res) => {
                    if (res?.status === 201) {
                        handleFormSuccess();
                        action.resetForm();
                        if (fileInputRef.current) {
                            fileInputRef.current.value = ''; // Set to empty string to clear file input
                        }
                        ToastSuccess({ message: res?.message });
                    } else if (res?.status === 400) {
                        ToastWarning({ message: res?.message?.tole_name });
                    }
                    else {
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                <SecHeading type='add' label='Postal Receive Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='reference_no'
                            label='Reference No'
                            handleChange={handleChange}
                            value={values.reference_no}
                            error={errors.reference_no}
                            handleBlur={handleBlur}
                            touched={touched.reference_no}
                            required={true}
                            placeholder='Enter Reference No.'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='date_ne'
                            label='Date (BS)'
                            handleChange={handleChange}
                            value={values.date_ne}
                            error={typeof errors.date_ne === 'string' ? errors.date_ne : undefined}
                            touched={touched.date_ne ? true : false} // Convert to a boolean
                            handleBlur={handleBlur}
                            required={true}
                            placeholder='XXXX/XX/XX'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='from_title'
                            label='From Title'
                            handleChange={handleChange}
                            value={values.from_title}
                            error={errors.from_title}
                            handleBlur={handleBlur}
                            touched={touched.from_title}
                            required={true}
                            placeholder='Enter From title'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='address'
                            label='Address'
                            handleChange={handleChange}
                            value={values.address}
                            error={errors.address}
                            handleBlur={handleBlur}
                            touched={touched.address}
                            required={true}
                            placeholder='Enter address'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='note'
                            label='Note'
                            handleChange={handleChange}
                            value={values.note}
                            error={errors.note}
                            handleBlur={handleBlur}
                            touched={touched.note}
                            required={false}
                            placeholder='Enter Notes'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='to_title'
                            label='To title'
                            handleChange={handleChange}
                            value={values.to_title}
                            error={errors.to_title}
                            handleBlur={handleBlur}
                            touched={touched.to_title}
                            required={true}
                            placeholder='Enter To title'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='letter_no'
                            label='Letter No.'
                            handleChange={handleChange}
                            value={values.letter_no}
                            error={errors.letter_no}
                            handleBlur={handleBlur}
                            touched={touched.letter_no}
                            required={true}
                            placeholder='Enter Letter No.'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                            <FileTextBox
                                type='file'
                                name='doc'
                                label='Docs'
                                ref={fileInputRef}
                                handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    const file = e.target.files?.[0];
                                    if (file) {
                                        setFieldValue("doc", file); // Handle the file change correctly
                                    }
                                }}
                                error={errors.doc}
                                handleBlur={handleBlur}
                                touched={touched.doc}
                                required={false}
                            />
                        </Grid>

                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default PostalCreateView